export enum AgreementType {
  CONSENTS = 'C',
  OPPOSITION = 'O'
}

export interface AgreementModel {
  id: string;
  name: string;
  description: string;
  shortDescription: string;
  longDescription: string;
  assentType: string;
  registration: string;
  modification: string;
  visualization: string;
  status:boolean
}

export interface AgreementsStateModel {
  agreementsList: Array<AgreementModel>;
  agreementsSave: any;
  checkInProgress: boolean;
  error?: any;
}

export class AgreementsAdapter {
  private readonly agreements: Array<AgreementModel>;
  private readonly checkInProgress: boolean;
  private readonly error: any;

  constructor(
    agreementsData: { agreements: any, checkInProgress?: boolean, error?: any },
  ) {
    const { agreements } = agreementsData;

    this.agreements = agreements?.agreements;

    this.checkInProgress = agreements?.checkInProgress;

    this.error = agreements?.error;
  }

  toStateModel() {
    return {
      agreementsList: this.agreements,
      checkInProgress: this.checkInProgress,
      error: this.error
    };
  }
}
